import pickBy from "lodash/pickBy"
import identity from "lodash/identity"

const clean = (obj) => pickBy(obj, identity)

export default clean
